// extracted by mini-css-extract-plugin
export default {"container":"SignBadge_container__MjCh4"};